import { Text, withDatasourceCheck, LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import React from 'react';

type MinistryLandingPageProps = ComponentProps & {
  fields: {
    items: any;
  } | any;
  layoutData: LayoutServiceData;
  rendering: any
};
// const renderComponent = (props: any) => {
//   const data= {
//     fields: props?.fields[0]
//   }
//   return (React.createElement(
//     "HeroSingleBanner",
//       data
//     )
//   )
// }
// function Header(props: any) {
//   return <props.element props={props} />;
// }
const MinistryLandingPage = (props: MinistryLandingPageProps): JSX.Element => {

  // const { route }:any = props?.layoutData;
  
  return (
    <section aria-label="Ministry landing page">
      <Text field={props.fields.heading} />
      {/* { renderComponent(props) } */}
      {/* <Header element='HeroSingleBanner' props={props?.fields[0]} /> */}
      {/* { component(props) } */}
      {/* <{`${props?.fields[0]?.componentName} `}/> */}
      {/* <Placeholder name="jss-main" rendering={props.rendering} locale={"en"} lang="ar"/> */}
    </section>
  )
}

export default withDatasourceCheck()<MinistryLandingPageProps>(MinistryLandingPage);
